import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CustomHttp } from '../../common/customHttp.service';
import { ApiUrl } from '../../common/apiUrls';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { MainAppComponent } from '../../layout/layout.component';
import {SampPointSearchFields } from '../../common/viewModels/GlobalRegistry/SampPointModel';
import { ToastrService } from 'ngx-toastr';
import { PagerService } from '../../common/pagerService';


declare var $: any;
@Component({
  selector: 'samppoints',
  templateUrl: './samppoints.component.html',
  styleUrls: ['./samppoints.component.scss']
})
export class SamplingPoints implements OnInit {
  sampPointForm: FormGroup;
  sampPointSearchForm: FormGroup;
  id: number;
  searchFields: SampPointSearchFields = new SampPointSearchFields();
  isNoRecords: boolean = true;
  isSubmitted: boolean = false;
  pager: any = {};
  pagedItems: any[];
 // pageResult: PageResultDto;
  length: number = 0;
  mainComponent: any;  
  $element: any;
  $content: any;

  constructor(public _router: Router, private _formBuilder: FormBuilder, private _pagerService: PagerService,
    private _http: CustomHttp,
    private _appUrl: ApiUrl, private _route: ActivatedRoute,
    private _mApp: MainAppComponent, private _toastrService: ToastrService) {
    this.mainComponent = _mApp;
  }

  ngOnInit() {
    this.pager.pageSize = localStorage.getItem('PageSize') ? parseInt(localStorage.getItem('PageSize')) : 10;
    this.pager.pageIndex = 0;
    this.pager.pageSizeOptions = this._pagerService.pageSizeOptions;
    this.CreateForm();
    this.sampPointSearchForm = this._formBuilder.group({
      Name: [''],
      SamplingPointId: [0],
    });
    this.BindStaticSearchData();
    this.setPage(this.pager);    
  }

  CreateForm() {
    this.sampPointForm = this._formBuilder.group({
      SamplingPointId: [0],
      Name: ['', Validators.compose([Validators.required, Validators.minLength(1), Validators.maxLength(100)])],
    });
  }

  BindStaticSearchData() {
    this.searchFields.PageNo = 0;
    this.searchFields.PageSize = this._pagerService.pageSize;
  }

  setPage(page: any) {
    this.pager.pageSize = page.pageSize;
    this.pager.pageIndex = page.pageIndex;
    this.GetSamplingPointsList(this.pager);
  }

  GetSamplingPointsList(page: any) {
    this.searchFields.PageNo = page.pageIndex;
    this.searchFields.PageSize = page.pageSize
    this._mApp.ShowLoader();
    this._http.post(this._appUrl.GetSampPointsList, this.searchFields)
      .subscribe(
      res => {
        var data = res.json();
        this.length = data.PageResult.TotalRecords;
        this.pagedItems = data.Result;
        this.isNoRecords = !(data.Result.length > 0);
        this._mApp.HideLoader();
      },
      error => {
        this._mApp.HideLoader();
        this._toastrService.error(error.json().Result, '');
      }
      );
  }

  GetSamplingPointById(id: number) {
    
    this._mApp.ShowLoader();   
    this._http.get(this._appUrl.GetSampPointById + id)
      .subscribe(
      m => {
        this._mApp.HideLoader();
        if (m.json().Result != null) {
          this.sampPointForm.setValue(m.json().Result);
        }
      }, error => {
        this._mApp.HideLoader();
        this._toastrService.error(error.json().Result, '');
      }
      )
  }

  DeleteSampPoint(id: any) {
    this.id = id;
  }


  DeleteSampPointById(id: number) {
    this._mApp.ShowLoader();
    this._http.get(this._appUrl.DeleteSampPoint + id)
      .subscribe(
      res => {
        this._mApp.HideLoader();
        this.setPage(this.pager);
        this._toastrService.success(res.json().Result, '');
      },
      error => {
        this._mApp.HideLoader();
        this._toastrService.error(error.json().Result, '');
      }
      );
  }

  onSearchSubmit() {
    this.pager.pageIndex = 0;
    let searchDto = this.sampPointSearchForm.value;
    if (searchDto.Name != null)
      this.searchFields.Name = searchDto.Name;
    this.setPage(this.pager);
  }

  onSubmit() {
    
    this.isSubmitted = true;
    if (this.sampPointForm.valid) {
      let unitsDto = this.sampPointForm.value;
      this._mApp.ShowLoader();
      if(unitsDto.SamplingPointId==null || unitsDto.SamplingPointId==0)
      {
        unitsDto.SamplingPointId=0;
      }
      this._http.post(this._appUrl.UpsertSampPoint, unitsDto)
        .subscribe(
        data => {
          this._mApp.HideLoader();
          this._toastrService.success(data.json().Result, '');
          $('#addSampPointModel').modal('toggle');
          this.Clear();
          this.setPage(this.pager);
        },
        error => {
          this._mApp.HideLoader();
          this._toastrService.error(error.json().Result, '');
        }
        );
    }
    else {
      $('#unitName').addClass("mat-input-invalid");
    }
  }

  Clear() {
    this.sampPointForm.reset();
    //this.CreateForm();
    this.RemoveInvalidCSS();
  }
  
  RemoveInvalidCSS() {
    $('#unitName').removeClass("mat-input-invalid");
  }

  OnReset() {
    this.sampPointSearchForm.reset();
    this.pager.pageSize = this._mApp.pageSize;
    this.pager.pageIndex = 0;
    this.searchFields.Name = '';
    this.setPage(this.pager);
  }
}
